import { Stack } from 'expo-router';

export default function CheckInEventLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="roster" />
    </Stack>
  );
}
